<div class="w-100 overflow-hidden position-relative card-header_image">
  <div *ngIf="showUpdatedTime" class="update-time">
    <ng-content select="[updatedOn]"></ng-content>
  </div>
  <ng-content></ng-content>
</div>
